export const StoreIcon = (props) => {
  // const { className } = props;

  return <h5 style={{ marginBottom: 0 }}>S</h5>;
};
